import api from './api';

/**
 * Chiamate dei referti.
 *
 * Il caricamento passa da FormData perche' porta un file: l'intestazione
 * multipart la mette il browser da se', e sovrascriverla a mano rompe il
 * confine fra le parti.
 */
export const refertiAPI = {
    perPaziente: (pazienteId, categoria) =>
        api.get(`/referti/paziente/${pazienteId}`, { params: { categoria } }),
    dettaglio: (id) => api.get(`/referti/${id}`),
    /* Content-Type undefined: l'istanza api ha application/json come
       predefinito, e lasciarlo manderebbe il multipart senza il confine
       fra le parti. Il browser lo calcola da se'. */
    carica: (pazienteId, formData) =>
        api.post(`/referti/paziente/${pazienteId}`, formData,
                 { headers: { 'Content-Type': undefined } }),
    aggiorna: (id, dati) => api.put(`/referti/${id}`, dati),
    elimina: (id) => api.delete(`/referti/${id}`),

    estrai: (id) => api.post(`/referti/${id}/estrai`),
    verificaTutti: (id) => api.post(`/referti/${id}/verifica-tutti`),

    aggiornaValore: (id, dati) => api.put(`/referti/valori/${id}`, dati),
    eliminaValore: (id) => api.delete(`/referti/valori/${id}`),

    // Senza `analita` torna l'elenco dei parametri disponibili
    andamento: (pazienteId, analita) =>
        api.get(`/referti/andamento/${pazienteId}`, { params: { analita } }),
    analiti: (q) => api.get('/referti/analiti', { params: { q } }),
};

export default refertiAPI;
